// src/pages/ThankYou.jsx
import React from "react";
import { Link } from "react-router-dom";

const ThankYou = () => {
  return (
    <section className="flex items-center justify-center   bg-green-50">
      <div className="text-center bg-white p-10 rounded-2xl shadow-md">
        <h1 className="text-3xl font-bold text-green-600">
          🎉 Payment Successful!
        </h1>
        <p className="mt-4 text-gray-700">Thank you for subscribing with us.</p>
        <Link
          to="/"
          className="mt-6 inline-block bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600"
        >
          Go to Home
        </Link>
      </div>
    </section>
  );
};

export default ThankYou;
